import { type StoreState } from '@rfc/rfc-components-library/store'
import type { NotificationProps } from '@rfc/rfc-components-library/types'
import type { CustomerState } from './customerStore/CustomerStoreTypes'
import type { FiltersState } from './filtersStore/FiltersStoreTypes'
import type { OrderState } from './orderStore/OrderStoreTypes'
import type { ProductState } from './productStore/ProductStoreTypes'
import type { TemplateState } from './templateStore/TemplateStoreTypes'

export type TagProducerStoreState = StoreState & {
    customer: CustomerState
    filters: FiltersState
    notification: NotificationProps
    order: OrderState
    product: ProductState
    printTemplate: TemplateState
}

export enum EStoreModules {
    CUSTOMER = 'customer',
    ORDER = 'order',
    PRODUCT = 'product',
    PRODUCTION_LINE = 'productionLine',
    PRINT_TEMPLATE = 'printTemplate'
}
